import React from 'react';
import TextField from 'material-ui/TextField';
import Dialog from 'material-ui/Dialog';
import FlatButton from 'material-ui/FlatButton';
import RaisedButton from 'material-ui/RaisedButton';
import { translate } from 'react-i18next';
import firebase from '../firebase';
import compose from '../compose';
import user from '../Auth/user';
import { Redirect } from 'react-router-dom';
import SelectField from 'material-ui/SelectField';
import MenuItem from 'material-ui/MenuItem';

class ProductCreate extends React.Component {
  constructor(props) {
    super(props);
    this.initialState = {
      name: '',
      description: '',
      nameError: '',
      priceError: '',
      vatError: '',
      productKey: null,
      price: '',
      vat: '0',
      redirectTo: '',
      picture: '',
      pictures: ''
    };

    this.state = {
      ...this.initialState
    };
  }

  componentWillReceiveProps = (nextProps) => {
    if(nextProps.product && nextProps.product.key !== this.props.product.key) {
      this.setState({
        name: nextProps.product.name,
        description: nextProps.product.description,
        picture: nextProps.product.picture,
        pictures: nextProps.product.pictures,
        vat: nextProps.product.vat
      });
    }
  }

  handleNameChange = (event, name) => this.setState({name, nameError: ''})
  handleDescriptionChange = (event, description) => this.setState({description})
  handlePriceChange = (event, price) => this.setState({price: price.trim().replace(',','.'), priceError: ''})
  handleVatChange = (event, index, vat) => this.setState({vat})

  validateName = () => {
    const {t} = this.props;
    if (!this.state.name) {
      this.setState({nameError: t('product.nameRequired')});
      return false;
    }
    return true;
  }

  validatePrice = () => {
    const price = this.state.price;
    const {t} = this.props;

    if (!price) {
      this.setState({priceError: t('product.priceRequired')});
      return false;
    } else if (isNaN(price)) {
      this.setState({priceError: t('product.priceNotNumber')});
      return false;
    } else if (parseFloat(price) < 0)  {
      this.setState({priceError: t('product.priceLessThanZero')});
      return false;
    } else if (parseFloat(parseFloat(price).toFixed(2)) !== parseFloat(price)) {
      this.setState({priceError: t('product.tooManyDecimals')});
      return false;
    }


    return true;
  }

  handleClose = () => {
    this.setState(this.initialState);
    this.props.handleClose();
  }

  handleSave = () => {
    const {firebase, user} = this.props;

    const valid = [this.validateName, this.validatePrice].map((fn) => fn()).every(x => (x));
    if (!valid) return;

    const product = {
      name: this.state.name,
      description: this.state.description,
      price: this.state.price,
      vat: this.state.vat,
      picture: this.state.picture,
      pictures: this.state.pictures
    };

    var pushRef = firebase.database()
      .ref('shopkeepers/' + user.shopkeeperId + '/products/')
      .push(product);

    if (this.props.addToStand) {
      product.key = pushRef.key;
      this.props.addToStand(true, product);
    }

    this.setState({redirectTo: pushRef.key});

  }
  render() {
    if (this.state.redirectTo) {
      return (
        <Redirect to={`/products/${this.state.redirectTo}`} push/>
      );
    }

    const {t} = this.props;
    const actions = [
      <FlatButton
        label={t('cancel')}
        onTouchTap={this.handleClose}
      />,
      <RaisedButton
        label={t('submit')}
        type="submit"
        primary={true}
        onTouchTap={this.handleSave}
      />,
    ];

    const dialogTitle = this.state.productKey ? t('product.edit') : t('product.create');

    return (
      <Dialog
        title={dialogTitle}
        open={this.props.open}
        onRequestClose={this.handleClose}
        actions={actions}
      >
        <TextField
          hintText={t('product.name')}
          floatingLabelText={t('product.name')}
          onBlur={this.validateName}
          errorText={this.state.nameError}
          onChange={this.handleNameChange}
          value={this.state.name}
        />
        <br />
        <TextField
          hintText={t('product.description')}
          floatingLabelText={t('product.description')}
          onChange={this.handleDescriptionChange}
          value={this.state.description}
        />
        <br />
        <TextField
          hintText={t('product.defaultPrice')}
          floatingLabelText={t('product.defaultPrice')}
          errorText={this.state.priceError}
          onChange={this.handlePriceChange}
          onBlur={this.validatePrice}
          value={this.state.price}
        />
        <br />
        <span style={{fontSize: '11px', color: '#BDBDBD'}}>
          {t('product.defaultPriceDesc')}
        </span>
        <br />
        <SelectField
          autoWidth={true}
          floatingLabelText={t('product.vat')}
          value={this.state.vat}
          onChange={this.handleVatChange}>
          <MenuItem value={'0'} primaryText="0 %" />
          <MenuItem value={'10'} primaryText="10 %" />
          <MenuItem value={'14'} primaryText="14 %" />
          <MenuItem value={'24'} primaryText="24 %" />
        </SelectField>
      </Dialog>
    );
  }
}

const enhance = compose(translate(), firebase, user);

export default enhance(ProductCreate);



// WEBPACK FOOTER //
// ./src/Product/ProductCreate.js